import { Box, Flex, Grid, GridItem, Image, Link } from "@chakra-ui/react";
import NextLink from "next/link";
import { useWindowSiteStore } from "@store/windowSiteStore";
import { scale } from "@utils/helpers";
import { useEffect, useState } from "react";
import { PaddedOnMobile } from "../layout";
import { motion } from "framer-motion";

const MotionGridItem = motion(GridItem);

type CollabsSectionProps = {};

export const CollabsSection = ({}: CollabsSectionProps) => {
    const isDesktop = useWindowSiteStore((state) => state.isDesktop);
    const windowWidth = useWindowSiteStore((state) => state.windowWidth);

    const minSize = isDesktop ? 960 : 375;
    const maxSize = isDesktop ? 1200 : 960;

    const slideRightAnimation = (delay = 0, once = true) => ({
        initial: {
            translateX: "-200px",
            opacity: 0,
        },
        whileInView: {
            translateX: "0px",
            opacity: 1,
        },
        transition: {
            duration: 0.8,
            ease: "easeOut",
            delay: delay,
        },
        viewport: {
            once: once,
        },
    });

    const slideLeftAnimation = (delay = 0, once = true) => ({
        initial: {
            translateX: "200px",
            opacity: 0,
        },
        whileInView: {
            translateX: "0px",
            opacity: 1,
        },
        transition: {
            duration: 0.8,
            ease: "easeOut",
            delay: delay,
        },
        viewport: {
            once: once,
        },
    });

    return (
        <>
            <Flex pos="relative" w="100%" minW="100vw" justify="center" align="center" py="100px">
                <Box
                    pos="absolute"
                    minW="100vw"
                    w="100vw"
                    h="100%"
                    minH="100%"
                    backgroundImage={`url('/images/backgrounds/floating-nfts.png')`}
                    backgroundRepeat="no-repeat"
                    backgroundPosition="center"
                    bgSize="auto 100%"
                    zIndex={0}
                />
                <PaddedOnMobile>
                    <Grid
                        w="100%"
                        maxW={isDesktop ? scale(windowWidth, minSize, maxSize, 640, 800)+"px" : "370px"}
                        mt={isDesktop ? 0 : -scale(windowWidth, minSize, maxSize, 4, 16)}
                        templateColumns={isDesktop ? "1fr 1fr" : "auto"}
                        templateRows={isDesktop ? "auto" : "auto auto"}
                        gap={10}
                        zIndex={1}
                        // border="1px solid white"
                    >
                        <MotionGridItem {...slideRightAnimation()}>
                            <Flex
                                direction="column"
                                w="100%"
                                h="100%"
                                justify={isDesktop ? "end" : "end"}
                                align={isDesktop ? "end" : "center"}
                                // bgColor="red"
                            >
                                <Image
                                    src="/images/br-lined-diamond.png"
                                    alt="Beyond Rarity: Lined Diamond"
                                    boxSize="85%"
                                    objectFit="contain"
                                />
                            </Flex>
                        </MotionGridItem>
                        <MotionGridItem {...slideLeftAnimation()}>
                            <Flex
                                direction="column"
                                w="100%"
                                justify="center"
                                align={isDesktop ? "start" : "center"}
                                // textAlign={isDesktop ? "start" : "justify"}
                            >
                                <Flex direction="column">
                                    <Box
                                        fontFamily="regular"
                                        fontSize={scale(windowWidth, minSize, maxSize, 12, 24)}
                                        color="hotOrange"
                                    >
                                        Collabs
                                    </Box>
                                    <Box
                                        fontFamily="regular"
                                        fontSize={scale(windowWidth, minSize, maxSize, 36, 48)}
                                        lineHeight="110%"
                                    >
                                        Alpha Groups
                                    </Box>
                                    <Box
                                        pt={2}
                                        pb={4}
                                        fontSize={scale(windowWidth, minSize, maxSize, 18, 24)}
                                        fontWeight="light"
                                    >
                                        We’d love to collab, reach out and see how we can add more
                                        utility to your group. We also offer group discounts to
                                        members of alpha groups in our network, so have your people
                                        call our people.{" "}
                                        <NextLink
                                            shallow
                                            href="mailto:alpha@beyondrarity.com"
                                            passHref
                                        >
                                            <Link
                                                href="mailto:alpha@beyondrarity.com"
                                                textStyle="site.linkStyle"
                                                color="sorbet"
                                            >
                                                alpha@beyondrarity.com
                                            </Link>
                                        </NextLink>
                                    </Box>
                                </Flex>
                            </Flex>
                        </MotionGridItem>
                    </Grid>
                </PaddedOnMobile>
            </Flex>
        </>
    );
};

export default CollabsSection;
